import { styled } from '@creditas-ui/react'

const StyledInputButtonSearch = styled.button`
  border: 0;
  padding: 0;
  position: absolute;
  width: 40px;
  height: 40px;
  right: 20px;
  top: 50%;
  outline: none;
  transform: translateY(-50%);
  padding: 8px;
  background: transparent;
  cursor: pointer;
  overflow: hidden;
`

export { StyledInputButtonSearch as InputButtonSearch }
